"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Theme = exports.Theme = {
    "seriesCnt": "6",
    "backgroundColor": "rgba(0, 0, 0, 0)",
    "titleColor": "#333333",
    "subtitleColor": "#999999",
    "textColorShow": false,
    "textColor": "#333",
    "markTextColor": "#ffffff",
    "color": ["#59acff", "#43d3e0", "#45e6b0", "#8ee065", "#face4b", "#ffb366", "#ff8066", "#ff6680", "#e667d0", "#aa61f2", "#7961f2", "#667fff", "#f7d83e", "#ffbf40", "#ff884d"],
    "borderColor": "rgba(204,204,204,0)",
    "borderWidth": "0",
    "visualMapColor": ["#ff8066", "#ffb366", "#f7d83e"],
    "legendTextColor": "#333",
    "kColor": "#c23531",
    "kColor0": "#314656",
    "kBorderColor": "#c23531",
    "kBorderColor0": "#314656",
    "kBorderWidth": 1,
    "lineWidth": "1",
    "symbolSize": "3",
    "symbol": "circle",
    "symbolBorderWidth": 1,
    "lineSmooth": false,
    "graphLineWidth": 1,
    "graphLineColor": "#aaa",
    "mapLabelColor": "#333333",
    "mapLabelColorE": "rgb(87,65,40)",
    "mapBorderColor": "#ffffff",
    "mapBorderColorE": "#544027",
    "mapBorderWidth": ".5",
    "mapBorderWidthE": "1",
    "mapAreaColor": "#eeeeee",
    "mapAreaColorE": "#ffe877",
    "axes": [{
        "type": "all",
        "name": "通用坐标轴",
        "axisLineShow": true,
        "axisLineColor": "#333",
        "axisTickShow": true,
        "axisTickColor": "#333",
        "axisLabelShow": true,
        "axisLabelColor": "#333",
        "splitLineShow": true,
        "splitLineColor": ["#ccc"],
        "splitAreaShow": false,
        "splitAreaColor": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
    }, {
        "type": "category",
        "name": "类目坐标轴",
        "axisLineShow": true,
        "axisLineColor": "#444444",
        "axisTickShow": false,
        "axisTickColor": "#333",
        "axisLabelShow": true,
        "axisLabelColor": "#333",
        "splitLineShow": true,
        "splitLineColor": ["#f2f2f2"],
        "splitAreaShow": false,
        "splitAreaColor": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
    }, {
        "type": "value",
        "name": "数值坐标轴",
        "axisLineShow": true,
        "axisLineColor": "#444444",
        "axisTickShow": false,
        "axisTickColor": "#333",
        "axisLabelShow": true,
        "axisLabelColor": "#333",
        "splitLineShow": true,
        "splitLineColor": ["#f2f2f2"],
        "splitAreaShow": false,
        "splitAreaColor": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
    }, {
        "type": "log",
        "name": "对数坐标轴",
        "axisLineShow": true,
        "axisLineColor": "#444444",
        "axisTickShow": false,
        "axisTickColor": "#333",
        "axisLabelShow": true,
        "axisLabelColor": "#333",
        "splitLineShow": true,
        "splitLineColor": ["#f2f2f2"],
        "splitAreaShow": false,
        "splitAreaColor": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
    }, {
        "type": "time",
        "name": "时间坐标轴",
        "axisLineShow": true,
        "axisLineColor": "#333",
        "axisTickShow": false,
        "axisTickColor": "#333",
        "axisLabelShow": true,
        "axisLabelColor": "#333",
        "splitLineShow": true,
        "splitLineColor": ["#f2f2f2"],
        "splitAreaShow": false,
        "splitAreaColor": ["rgba(250,250,250,0.3)", "rgba(200,200,200,0.3)"]
    }],
    "axisSeperateSetting": true,
    "toolboxColor": "#444444",
    "toolboxEmpasisColor": "#000000",
    "tooltipAxisColor": "#ccc",
    "tooltipAxisWidth": "1",
    "timelineLineColor": "#999999",
    "timelineLineWidth": "1",
    "timelineItemColor": "#999999",
    "timelineItemColorE": "#59acff",
    "timelineCheckColor": "#59acff",
    "timelineCheckBorderColor": "rgba(194,53,49,0)",
    "timelineItemBorderWidth": "1",
    "timelineControlColor": "#999999",
    "timelineControlBorderColor": "#999999",
    "timelineControlBorderWidth": ".5",
    "timelineLabelColor": "#999999",
    "datazoomBackgroundColor": "rgba(47,69,84,0)",
    "datazoomDataColor": "rgba(47,69,84,0.3)",
    "datazoomFillColor": "rgba(167,183,204,0.4)",
    "datazoomHandleColor": "#a7b7cc",
    "datazoomHandleWidth": "100",
    "datazoomLabelColor": "#333"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/common/theme.js
// module id = 257
// module chunks = 0